import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { REGULAR_PATH } from '../../../env';
import { Button, Dimmer, Loader } from 'semantic-ui-react';

class JoinGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      groupName: '',
      status: '',
      loading: true,
      submit: false,
    };
  }

  componentDidMount() {
    this.verifyURL();
  }

  verifyURL = () => {
    axios
      .get(
        `${REGULAR_PATH}/organization/join?request_id=${this.props.match.params.id}`,
      )
      .then((res) => {
        this.setState({
          message: res.data.message,
          groupName: res.data.group_name,
          status: res.data.status,
          loading: false,
        });
      })
      .catch((e) => {
        this.setState({
          message: 'Invalid Link',
          success: false,
          loading: false,
        });
      });
  };

  handleSubmit = (type) => {
    const { id } = this.props.match.params;
    this.setState({ submit: true });
    axios
      .put(
        `${REGULAR_PATH}/organization/join`,
        JSON.stringify({
          status: type === 'accept' ? 'accepted' : 'declined',
          request_id: id,
        }),
      )
      .then((res) => {
        if (res.data.status === 'success') {
          this.setState({
            submit: false,
            message: `You have ${
              type === 'accept' ? 'accepted' : 'declined'
            } the request`,
          });
        }
      })
      .catch((e) => {
        this.setState({ message: 'error', submit: false });
      });
  };

  render() {
    const { message, groupName, status, loading, submit } = this.state;

    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader size='large'>Loading...</Loader>
        </Dimmer>
      );
    }

    return (
      <div className='ui two column centered grid login-flow '>
        <div className='column'>
          <Link to='/'>
            <img
              className='logo'
              src='/images/Logo-1.png'
              width='300'
              alt='Finder logo'
            />
          </Link>

          {status === 'success' ? (
            <div
              className='ui stacked segment'
              style={{ padding: 30, color: '#000' }}
            >
              {message === 'success' ? (
                <div>
                  <h3>Join Group {groupName}?</h3>
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                      justifyContent: 'center',
                      marginTop: '20px',
                    }}
                  >
                    <Button
                      color='green'
                      disabled={submit}
                      onClick={() => this.handleSubmit('accept')}
                    >
                      Accept
                    </Button>
                    <Button
                      color='red'
                      disabled={submit}
                      onClick={() => this.handleSubmit('decline')}
                    >
                      Declined
                    </Button>
                  </div>
                </div>
              ) : (
                <h3>{message}</h3>
              )}
            </div>
          ) : (
            <div style={{ marginTop: '20px' }}>
              <div
                className='ui stacked segment'
                style={{ padding: 30, color: '#000' }}
              >
                <h3>Invalid or expired link</h3>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default JoinGroup;
